import { render, staticRenderFns } from "./promotion.vue?vue&type=template&id=a862340a&scoped=true"
import script from "./promotion.vue?vue&type=script&lang=js"
export * from "./promotion.vue?vue&type=script&lang=js"
import style0 from "./promotion.vue?vue&type=style&index=0&id=a862340a&prod&lang=scss"
import style1 from "./promotion.vue?vue&type=style&index=1&id=a862340a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a862340a",
  null
  
)

export default component.exports